var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFilmSlate = function SvgIconFilmSlate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.403 1.788a1.7 1.7 0 0 0-.677.05l-5.688 1.525q-.101.015-.196.052l-8.59 2.302H3.25a1.75 1.75 0 0 0-1.244 2.144l.745 2.772v8.117A1.75 1.75 0 0 0 4.5 20.5h15a1.75 1.75 0 0 0 1.75-1.75V10.5a1 1 0 0 0-1-1h-8.913L17 7.981q.051-.01.102-.027l2.845-.763a1 1 0 0 0 .707-1.225l-.776-2.891-.002-.004a1.74 1.74 0 0 0-1.472-1.283M8.267 6.444l3.795-1.017L14.2 6.66 10.403 7.68zm-2.73.731-1.534.412.453 1.688 3.219-.863zm9.257-2.48 2.137 1.234 1.531-.41-.453-1.686zM4.75 18.5v-7h14.5v7z",
    clipRule: "evenodd"
  })));
};
export default SvgIconFilmSlate;